import { useEffect } from 'react';

/**
 * Pauses the given video element whenever the document becomes hidden (tab switch, window minimize,
 * etc.). Prevents the player from continuing to fetch segments — and Mux from continuing to bill for
 * delivery — while nobody is watching. Does not auto-resume on return: the user re-initiates playback.
 */
export function usePauseOnHidden(videoRef: React.RefObject<HTMLVideoElement | null>): void {
	useEffect(() => {
		const handleVisibilityChange = () => {
			if (document.visibilityState !== 'hidden') return;
			const videoEl = videoRef.current;
			if (videoEl && !videoEl.paused) {
				videoEl.pause();
			}
		};
		document.addEventListener('visibilitychange', handleVisibilityChange);
		return () => {
			document.removeEventListener('visibilitychange', handleVisibilityChange);
		};
	}, [videoRef]);
}
